export default {"src":"/_next/static/media/dolars.7654c383.svg","height":96,"width":96};